import styled from 'styled-components';
import {FiAlertCircle, FiCheck} from 'react-icons/fi';

const InputWrapper = styled.div`
  margin-top: ${({theme}) => theme.spacing.xsmall};
  margin-bottom: ${({theme}) => theme.spacing.xsmall};
  position: relative;
`;

const InputItem = styled.input`
  height: 54px;
  width: 100%;
  padding: 0 ${({theme}) => theme.spacing.small};
  outline: none;
  font-size: ${({theme}) => theme.fontSize.default};
  border: 2px solid
    ${({theme, error, valid}) => (error ? theme.colors.red : valid ? theme.colors.green : theme.colors.lightgray)};
`;

const TextAreaItem = styled.textarea`
  min-height: 150px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  padding: ${({theme}) => theme.spacing.small};
  outline: none;
  font-size: ${({theme}) => theme.fontSize.default};
  border: 2px solid
    ${({theme, error, valid}) => (error ? theme.colors.red : valid ? theme.colors.green : theme.colors.lightgray)};
`;

const Icon = styled.div`
  position: absolute;
  top: ${({top, theme}) => (top ? theme.spacing.small : 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${({top}) => (top ? null : `100%`)};
  right: ${({theme}) => theme.spacing.small};
  color: ${({error, valid, theme}) => (error ? theme.colors.red : valid ? theme.colors.green : theme.colors.lightgray)};
  & > svg {
    stroke-width: 2.5;
  }
`;

export const Input = ({
  placeholder,
  name,
  type,
  handleChange = () => {},
  value,
  error,
  touched,
  setFieldTouched = () => {},
}) => (
  <InputWrapper>
    <InputItem
      name={name}
      type={type}
      placeholder={placeholder}
      valid={!error && touched}
      autocomplete='off'
      onChange={(e) => {
        handleChange(e);
        setFieldTouched(name);
      }}
      value={value}
      error={error && touched ? error : false}
    />
    {error && touched && (
      <Icon error>
        <FiAlertCircle />
      </Icon>
    )}
    {!error && touched && (
      <Icon valid>
        <FiCheck />
      </Icon>
    )}
  </InputWrapper>
);

export const TextArea = ({
  placeholder,
  name,
  type,
  handleChange = () => {},
  value,
  error,
  touched,
  setFieldTouched = () => {},
}) => (
  <InputWrapper>
    <TextAreaItem
      name={name}
      type={type}
      placeholder={placeholder}
      autocomplete='off'
      onChange={(e) => {
        handleChange(e);
        setFieldTouched(name);
      }}
      valid={!error && touched}
      value={value}
      error={error && touched ? error : false}
    />
    {error && touched && (
      <Icon top error>
        <FiAlertCircle />
      </Icon>
    )}
    {!error && touched && (
      <Icon top valid>
        <FiCheck />
      </Icon>
    )}
  </InputWrapper>
);

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Button = styled.button`
  margin-top: ${({theme}) => theme.spacing.xsmall};
  margin-bottom: ${({theme}) => theme.spacing.xsmall};
  text-transform: uppercase;
  height: 54px;
  width: 100%;
  padding: 0 ${({theme}) => theme.spacing.small};
  background-color: ${({theme}) => theme.colors.green};
  color: ${({theme}) => theme.colors.white};
  cursor: pointer;
  outline: none;
  border: none;
  font-size: ${({theme}) => theme.fontSize.small};
  font-weight: bold;
  &:hover {
    opacity: 0.9;
  }
`;
